import { useShowTotal } from 'store/selectors/hooks/useShowTotal';
import FormatUtils from 'utils/format';
import { useAirportPriceExperiment } from './use-airport-price-experiment';
import UserUtils from 'utils/user-utils';
// During clean up or implementation, migrate to useLabel hook if possible instead of creating a new hook.
// This is created specifically for airport pirce experimentation
export const useLabelForAirport = spot => {
    const showTotal = useShowTotal();
    const { hideTotalToggle, hideTotalToggleVariant2, } = useAirportPriceExperiment();
    const selectedRate = spot?.selectedRate || {};
    const defaultPrice = {
        value: 0,
        currencyCode: UserUtils.CURRENCY_TYPES.DEFAULT,
    };
    if (hideTotalToggle) {
        const advertisedPrice = selectedRate?.advertisedPrice || defaultPrice;
        const currencySymbol = FormatUtils.currencySymbol(advertisedPrice.currencyCode);
        const { dollars, cents } = FormatUtils.price(advertisedPrice.value);
        const formattedAdvertisedPrice = `${currencySymbol}${dollars.replace('-', '')}${cents ? `.${cents}` : ''} per day`;
        return formattedAdvertisedPrice;
    }
    if (hideTotalToggleVariant2) {
        const totalPrice = selectedRate?.totalPrice || defaultPrice;
        const currencySymbol = FormatUtils.currencySymbol(totalPrice.currencyCode);
        const { dollars, cents } = FormatUtils.price(totalPrice.value);
        const formattedTotalPrice = `${currencySymbol}${dollars.replace('-', '')}${cents ? `.${cents}` : ''} total`;
        return formattedTotalPrice;
    }
    return showTotal ? 'Total' : 'Per Day';
};
